import React, { useState } from "react";
import { useSelector } from "react-redux";
import Layout from "../../../components/dashboard/Layout";
import CirclesStudentsTable from "../../../containers/admin/students/circlesStudents";
import AddStudent from "../../../containers/admin/students/models/add-student";
import ShowPassword from "../../../containers/admin/students/models/show-password";
import StudentReport from "../../../containers/admin/students/models/student-report";
import UserQRCode from "../../../containers/admin/students/models/user-qr-code";
import SearchBar from "../../../containers/admin/students/searchbar";
import StudentsTable from "../../../containers/admin/students/table";
import AddSubjectAdmin from "../../../containers/admin/teachers/models/add-subject-admin";
import ShowSubjectAdminData from "../../../containers/admin/students/models/show-subject-admin-data";

const Students = () => {
  const model = useSelector((state) => state.model.isOpen18);
  const [addedStudent, setAddedStudent] = useState({});
  const [addedSubjectAdmin, setAddedSubjectAdmin] = useState({});
  const [isAdd, setAdd] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const userData = useSelector((state) => state.user.userData);
  return (
    <Layout>
      <SearchBar
        setAdd={setAdd}
        setSelectedData={setSelectedData}
        setSearchTerm={setSearchTerm}
      />

      <CirclesStudentsTable
        setAdd={setAdd}
        setSelectedData={setSelectedData}
        searchTerm={searchTerm}
      />


      <AddStudent
        isAdd={isAdd}
        data={selectedData}
        setAddedStudent={setAddedStudent}
      />
      <UserQRCode data={selectedData} setSelectedData={setSelectedData} />
      <ShowPassword data={addedStudent} />
      <AddSubjectAdmin
        isAdd={true}
        data={selectedData}
        setSelectedData={setSelectedData}
        setAddedSubjectAdmin={setAddedSubjectAdmin}
      />
      <ShowSubjectAdminData data={addedSubjectAdmin} />
      {model && (
        <StudentReport
          student_id={selectedData?.id}
          selectedData={selectedData}
        />
      )}
    </Layout>
  );
};

export default Students;
